const sendGaEvent = (event = 'leadGenerated') => {
  if (window.dataLayer) {
    window.dataLayer.push({ event });
  }
};
export default sendGaEvent;
